























































import {
  defineComponent,
} from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';
import JetUiButton from '~/components/JetUi/atoms/JetUiButton/JetUiButton.vue';
import Warning from '~/components/JetUi/atoms/Warning/Warning.vue';
import { usePaymentCard } from '~/composables';

export default defineComponent({
  name: 'CardPaymentComponent',
  components: {
    JetUiButton,
    SvgImage,
    Warning,
  },
  props: {
    selectedCardObject: {
      type: Object,
      required: true,
    },
    success: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const { decrypt } = usePaymentCard();

    function censoredText(text: string) {
      return text.replace(/\S/g, (char, index) => (index < 14 ? '\u25CF' : char));
    }

    return {
      censoredText,
      decrypt,
    };
  },
});
